import React, { useCallback, useMemo } from 'react';
import { generatePath } from 'react-router';
import { useStableParams } from '../../../../routes/useStableParams';
import { ROUTES } from '../../../menu/getMenuLeftItems';
import { OpenLinkButton } from '@ydistri/ds';

interface ShowSKUAsMainProps {
  skuId: number;
  onShowSkuAsMain: (skuId: number) => void;
}

/**
 * Icon button to show SKU as main.
 * @param skuId
 * @param onShowSkuAsMain
 * @constructor
 */
const ShowSKUAsMain: React.FC<ShowSKUAsMainProps> = ({ skuId, onShowSkuAsMain }) => {
  const { projectShortName, slug } = useStableParams();

  const link = useMemo(
    () => `${generatePath(ROUTES.detail, { projectShortName, slug })}?sku=${skuId}`,
    [projectShortName, slug, skuId],
  );

  const onLinkButtonClick = useCallback(() => {
    onShowSkuAsMain(skuId);
  }, [onShowSkuAsMain, skuId]);

  return <OpenLinkButton onButtonClick={onLinkButtonClick} link={link} tooltip="Show in detail" />;
};

export default ShowSKUAsMain;
